<template>
  <div id="lottery">
    <div class="li-box">
      <ul>
        <li v-for="(it, i) in 10" :key="i">{{(Number(ball) + i) % 10}}</li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  props: ["ball"],
  name: "lottery",
  created() {
    // console.log(this.ball);
  },
  data() {
    return {};
  },
  computed: {}
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>


// WEBPACK FOOTER //
// src/components/Lottery/index.vue